import AbsractGraphQL from './AbstractGraphQL';
import { HELPDESK_SERVICE_URL } from '../config';
import {
    delay
} from '../constants'
class HelpdeskGraphQL extends AbsractGraphQL {
    static async run({ query, variables, queryName, headers }) {
        let retries = 20
        for (let index = 0; index < retries; index++) {
            await delay(index*index*1000);
            let response = null;
            try {
                response = await this.request(query, variables, headers)
            } catch(e){
                console.log(e)
                if(index === retries-1){
                    throw e
                }
            }
            if(!response){
                continue;
            }
            const { data, errors } = response
            if (errors && errors.length > 0) {
                const message = errors[0].message
                if (message === 'read ECONNRESET') {
                    continue
                } else {
                    return data[queryName]
                }
            } else {
                return data[queryName]
            }
        }
    }
}

HelpdeskGraphQL.setURL(HELPDESK_SERVICE_URL)
export default HelpdeskGraphQL